<template>
<div class="out-container">
  <!-- <div class="radiobut" v-if="permission.selfFund_audit">  
      <el-badge :value="examinelist" class="examine_length">
        <el-radio-group v-model="margintap">
        <el-radio-button label="0">全部主体</el-radio-button>
        <el-radio-button label="1">审核列表</el-radio-button>
      </el-radio-group>
      </el-badge>
  </div>   -->
  <div class="master-fund-crudblock">
    <avue-crud
      :option="option"
      :data="data"
      v-model="form"
      :page.sync="page"
      :search.sync="form"
      :summary-method="summaryMethod"
      @search-reset="searchReset"
      @on-load="onLoad"
      @search-change="searchChange"
      @sort-change="sortChange"
      @selection-change="selectionChange"      
    >
      <template slot="search">
        <div class="block">
          <el-form-item label="设立时间">
            <el-date-picker
              v-model="timepic"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form_slot">
          <el-form-item label="注册资本">
            <el-input-number
              v-model="form.peScaleMin"
              :controls="false"
              placeholder="开始数值"
              style="width: 30%"
            />
            ~
            <el-input-number
              v-model="form.peScaleMax"
              :controls="false"
              placeholder="结束数值"
              style="width: 30%"
            />
          </el-form-item>
        </div>
      </template>

      <template slot="fundDetail" slot-scope="{ row }">
        <div class="fund-detail">
          <span v-if="row['eventNum'] == 0" class="gray-text">暂无</span>
          <span v-else class="blue-text">{{row.eventNum}}个明细</span>
          <a-popover
            placement="right"
            trigger="hover">
            <template slot="content">
              <div class="fund-right-content" >
                <el-button class="right-btn" type="text" size="small" @click="goAddEvent(0, row)">投资事件-股权投资</el-button>
                <el-button class="right-btn" type="text" size="small" @click="goAddEvent(1, row)">退出事件-股权退出</el-button>
                <el-button class="right-btn" type="text" size="small" style="margin-bottom:0 !important;" @click="goAddEvent(2, row)">分红</el-button>
              </div>
            </template>
            <i  class="el-icon-plus plus-right" style="cursor:pointer;"></i>
          </a-popover>
        </div>
      </template>
      <template slot="searchMenu" slot-scope="{ row }">
        <el-button type="primary" @click="save(row)">保存</el-button>
      </template>
      <template slot="menuRight">
        <el-tooltip class="item" effect="dark" content="显隐" placement="top">
          <el-button
            icon="el-icon-s-operation"
            circle
            @click="operation"
          ></el-button>
        </el-tooltip>
      </template>
      <template slot="menuLeft">
        <el-button
          size="small"
          type="primary"
          v-if="permission.selfFund_add && margintap == 0"
          icon="el-icon-plus"
          @click="handleEdit(-1)"
        >
          新增出资主体
        </el-button>
            <!-- scope.row.auditState != 1 &&
            scope.row.managerUser == userInfo.user_id -->
        <el-button
          type="primary"
          plain
          size="small"
          icon="el-icon-edit"
          v-if="
            permission.selfFund_edit && margintap == 0
          "
          :disabled="disabled || selectionList.length > 1"
          @click.stop="handleEdit"
          >编辑
        </el-button>

        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete-solid"
          v-if="
            permission.selfFund_del && margintap == 0
          "
          :disabled="disabled"
          @click.stop="handleDel"
          >删除
        </el-button>

        <el-button
          size="small"
          plain
          @click="exportShow"
          icon="el-icon-download"
          >导出数据
        </el-button>

      </template>

      <template slot="name" slot-scope="{ row }">
        <div class="project-name" @click="goDetail(row)">{{row.name}}</div>
      </template>

    </avue-crud>

    <!-- 2021/12/24 新增数据导入 -->
    <uploadForm
      uploadUrl="/api/fund/master/import-master"
      openUrl="/api/fund/master/export-template"
      uploadTitle="出资主体数据导入"
      @refreshData='refreshList'
      ref="uploadDialog" />

    <ExportData ref="exportData" :isFundExport='true' @exportDownload="exportDownload" />
    <Options
      ref="Options"
      :plainOptions="optionColumn"
      :pageDataId="this.$route.path"
      @returnData="returnData"
    />

    <el-dialog
      :close-on-click-modal="false" 
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="75%"
    >
      <InvestEventAdd
        ref="eventAdd"
        :isDetail="isDetail"
        :id="projectId"
        :addType="addType"
        eventBelongType="1"
        :eventId="eventId"
        @addSuccess="addSuccess"
      />
    </el-dialog>
  </div>
</div>

</template>

<script>
import * as api from "@/api/fund/masterfund";
import * as util from "@/util/util";
import { mapGetters } from "vuex";
import { downLoadTemplate } from "@/router/downLoadTem";
import ExportData from "@/components/exportData/exportData";
import uploadForm from "@/components/uploadForm/uploadForm";
import Options from "@/components/ShowHidden/showhidden";
import { tableConfig } from "./cofig";
import InvestEventAdd from "@/components/fundComponent/investEventAdd"
const optionColumn = tableConfig(util.getMoney).column;
export default {
  data() {
    return {
      projectId: '',
      isDetail: false,
      dialogTitle: '',
      eventId: '',
      dialogVisible: false,
      addType: '',
      disabled: true,
      examinelist: 0,
      margintap: '0',
      selectionList: [],
      optionColumn,
      shlb: 0,
      form: {},
      timepic: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev,next",
        background: false,
        pageSize: 10,
      },
      data: [],
      totalData: '',
      option: tableConfig(this.getMoney),
    };
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
  },
  watch: {
    'margintap': {
      handler(newValue, oldValue) {
        this.onLoad(this.page)
      },
    },
    selectionList: {
      handler(data) {
        let list = data.filter((item) => {
          return (
            this.userInfo.user_id == item.managerUser 
            && 1 != item.auditState
          );
        });
        this.disabled=false
        // this.disabled = list.length != data.length || data.length == 0;
      },
      deep: true,
    },    
    files: {
      handler(newName, oldName) {
        if (oldName != undefined) {
          this.cloudTages(newName);
        }
      },

      immediate: true,
    },
    timepic: {
      handler(newName, oldName) {
        if (oldName != undefined) {
          (this.form.establishmentTimeStart = this.timepic[0]),
            (this.form.establishmentTimeEnd = this.timepic[1]);
        }
      },

      immediate: true,
    },
  },
  props: ["files"],

  components: {
    Options,
    InvestEventAdd,
    ExportData,
    uploadForm
  },
  activated() {
    this.onLoad(this.page);
  },
  methods: {
    summaryMethod({ columns, data }) {
      const self = this
      const sums = [];
      // let arrays = this.tableConfig.selection?[5,6,7,9]:[4,5,6,8]
      let arrays = ['peScale','totalCapitalPaid','directInvestScale','cooperationFundSubscribed','cooperationFundPaid','cooperationFundPaid']
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if (arrays.includes(column.property)) {
            // 赋值totalData
            sums[index] = self.getMoney(Math.round(Number(self.totalData[column.property])/10000*100)/100)
          } else {
            sums[index] = "";
          }
        });
      }
      sums[1]="合计:"
      return sums;
    },
    selectionChange(data) {
      this.selectionList = data
    },
    goDetail(data) {
      this.$router.push({ path: `/selfFund/investMainBody/detail/${data.id}` });
    },
    refreshList(){
      this.onLoad(this.page)
    },
    showUpload() {
      this.$refs.uploadDialog.showModel()
    },
    //显隐
    operation() {
      let origencolum = this.option.column;
      this.$refs.Options.showmode();
    },
    returnData(data) {
      if (data.length != 0) {
        this.option.column = data;
      }
    },
    //排序
    sortChange(val) {
      this.form.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";
      this.form.orderName = val.prop;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    onLoad(page) {
      if(!this.permission.selfFund_add){
        this.option.selection = false
      }else {
        this.option.selection = true
      }      
      let data = {
        firstNum: (page.currentPage - 1) * page.pageSize,
        num: page.pageSize,
        bizType: '2',
        ...this.form,
      };
      if(this.margintap == 0 ) {
        // this.queryAuditNum()
        api
          .getList(data)
          .then(async(res) => {
            this.auditlistNub = res.data.data.shlb;
            this.page.total = res.data.data.total;
            this.data = res.data.data.records;
            let params = {
              firstNum: (this.page.currentPage - 1) * this.page.pageSize,
              num: this.page.pageSize,
              bizType: '2',
              ...this.form,
            }            
            let totalData = await api.getListTotal(params)
            this.totalData = totalData.data.data
          })
          .catch((res) => {
            this.$message({
              type: "warning",
              message: res.data,
            });
            console.log(res);
          });
      }else {
        // this.queryAuditNum()
      }

    },

    async queryAuditNum() {
      let params = {
        firstNum: (this.page.currentPage - 1) * this.page.pageSize,
        num: this.page.pageSize,
        bizType: '2',
        ...this.form,
        auditState: 1,
        
      };
      let res = await api.getList(params)
      if(res.data.code == 200) {
        if(this.margintap == 1) {
          this.auditlistNub = res.data.data.shlb;
          this.page.total = res.data.data.total;
          this.examinelist = res.data.data.total
          this.data = res.data.data.records;
          this.option.selection=false
        }else {
          this.examinelist = res.data.data.total
          this.option.selection=true
        }
      }
    },

    searchChange(params, done) {
      this.page.currentPage = 1;
      this.form.search=this.form.search1 ? this.form.search1 : ""
      if (this.timepic) {
        this.form.establishmentTimeStart = this.timepic[0];
        this.form.establishmentTimeEnd = this.timepic[1];
      } else {
        delete this.form["establishmentTimeStart"];
        delete this.form["establishmentTimeEnd"];
      }

      this.onLoad(this.page);
      done();
    },
    searchReset() {
      this.form.peScaleMin = undefined;
      this.form.peScaleMax = undefined;
      this.form.auditState = undefined;
      this.form.search = undefined;
      this.form.search1 = undefined;
      this.timepic = [];
      this.form = {};
      this.onLoad(this.page);
    },
    save(row) {
      this.$emit("rowdata", row);
    },
    cloudTages(data) {
      this.form = {};
      this.timepic = [];
      this.form = data;
      if (this.form.establishmentTimeStart) {
        this.timepic = [
          this.form.establishmentTimeStart,
          this.form.establishmentTimeEnd,
        ];
      }
      this.searchChange(data);
    },
    handleDetails(id) {
      this.$router.push({ path: `/selfFund/investMainBody/detail/${id}` });
    },
    handleEdit(params) {
      if (params == "-1") {
        this.$router.push({ path: `/selfFund/investMainBody/add/-1` });
      } else {
        if(this.selectionList.length > 1){
          this.$message.error('只能选择一条数据进行编辑')
        } else if(this.selectionList.length == 1){
          let data = this.selectionList[0]
          // if(data.auditState == 0 || data.auditState == 2) {
            // if(data.managerUser == this.userInfo.user_id ){
              this.$router.push({ path: `/selfFund/investMainBody/edit/${data.id}` });
            // }else {
            //   this.$message.warning('您暂无权限对该条数据进行编辑')
            // }
          // }else {
          //   this.$message.warning('该条数据已提交审核无法编辑')
          // }
        }else {
          this.$message.error('请选择一条数据进行编辑')
        }
      }
    },
    exportout() {
      let data = this.form;
      data.firstNum = "";
      data.num = "";
      delete data["$auditState"];
      delete data["$bankState"];
      let exceldata = this.daochu(data);

      this.$export.excel({
        title: "出资主体管理",
        columns: this.option.column,
        data: exceldata,
      });
    },
    daochu(data) {
      api.bankmessagegetList(data).then((res) => {
        return res.data.data.list;
      });
    },

    handleDel() {
      if(this.selectionList.length > 1){
          this.$message.error('只能选择一条数据进行删除')
      } else if(this.selectionList.length == 1){
        let data = this.selectionList[0]
        if(data.auditState == 0 ){
          // if( data.managerUser == this.userInfo.user_id ) {
            this.deleteFund(data.id)
          // }else {
          //   this.$message.warning('您暂无权限对该条数据进行删除')
          // }
        }else {
          this.$message.warning('该条数据已提交审核无法删除')
        }
      }else{
          this.$message.error('请选择数据进行删除')
      }
    },

    deleteFund(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api
            .deleteonlist({ ids: id })
            .then((res) => {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.onLoad(this.page);
            })
            .catch((res) => {
              this.$message({
                type: "warning",
                message: res.data,
              });
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 查看事件列表
    showEvent(data) {
      this.$router.push({
        path: `/selfFund/investMainBody/detail/${data.id}`,
        query: {
          active: 'list'
        }        
      })
    },
    //投资/退出明细
    goAddEvent(type, row) {
      // if(row.managerUser!=this.userInfo.user_id){
      //     this.$message({
      //     type: "warning",
      //     message: "您暂无权限进行此操作，请核对是否为其基金对接人。",
      //     });
      //     return
      // }
        this.isDetail = false
        this.dialogTitle = type==0?'新增股权投资':type==1?'新增股权退出':'新增分红'
        this.eventId = ''
        this.projectId = row.id
        this.addType = type
        if(this.$refs.eventAdd){
          this.$refs.eventAdd.cleanData()
        }
        this.dialogVisible = true
    },

    addSuccess() {
      this.onLoad()
      this.dialogVisible = false
    },
    exportShow() {
      this.$refs.exportData.showModel();
    },
    exportDownload(value) {
      let page = this.page;
       let data = {
        export: value.code,
       };
       let form = this.form;
       if (value.code == 1) {
        data = {
        firstNum: (page.currentPage - 1) * page.pageSize,
        num: page.pageSize,
          ...this.query,
          ...data,
          ...form,
        };
       } else if (value.code == 2) {
        delete form["firstNum"];
        delete form["num"];
        data = {
          ...this.query,
          ...data,
          ...form,
        };
       }
       if(value.code == 4){
         downLoadTemplate('/api/fund/master/exportOriginalData', {}).finally(() => {
           this.loading = false
            this.$message({
              type: "success",
              message: "已下载",
            });
         })
       }else {
          downLoadTemplate("/api/fund/master/export", data).finally(() => {
            this.loading = false;
            this.$message({
              type: "success",
              message: "已下载",
            });
          });
       }

    },
  },
};
</script>

<style lang="scss">
.ant-popover-placement-right{
  width: 170px !important;
}
.bankmanage {

  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .master-fund-crudblock {
    background: #ffff;
    padding: 16px;
    border-radius: 4px;
    .el-table__fixed, .el-table__fixed-right {
        height: calc(100% - 0px) !important;
    }
    .project-name{
      // overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
      color: #409EFF;
    }
    .project-name:hover{
      color: #409EFF;
      cursor: pointer;
    }
    .el-table {
      display: flex !important;
      flex-direction: column !important;
    }

    //  order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 
    .el-table__body-wrapper {
      order: 1 !important;
    }

    .el-table__fixed-footer-wrapper{
      top:40px !important;
      z-index: 0;
    }
    .el-table__fixed-body-wrapper{
      top: 80px !important
    }
    .el-dialog__header {
      border-radius: 5px 5px 0px 0px;
      // background-color: rgb(245, 245, 245);
      color: #333;
    }
    .el-dialog__body {
      padding: 10px 20px 20px !important;
    }    
  }
  /deep/.el-table .cell, /deep/.el-table th>.cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  /deep/.el-table .cell{
    font-size: 14px;
  }
  .el-table .cell, .el-table th>.cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .el-table .cell{
    font-size: 14px;
  }
}
td div .bankstatediv {
  display: flex;
  flex-direction: row;
  align-items: center;

  .bankstatespan {
    display: inline-block;
    width: 8px;
    height: 8px;
    justify-content: center;
    background: red;
    margin-right: 5px;
    border-radius: 50%;
  }
  .bankstate_0 {
    background: #fec03d;
  }
  .bankstate_1 {
    background: #51d351;
  }
  .bankstate_2 {
    background: #ff7a8c;
  }
}
td div .contactName {
  display: flex;
  flex-direction: column;
}
.bankmanage .el-date-editor .el-range__icon {
  line-height: 24px;
}
.bankmanage .avue-crud .el-input__inner,
.bankmanage .avue-form .el-input__inner {
  line-height: 30px;
  height: 30px;
}
.fund-right-content{
  .right-btn{
    margin-left: 0 !important;
    margin-bottom: 10px;
    width: 100%;
    color: black;
    font-size: 14px;
  }
   .right-btn:hover{
     color:#64b0ff  ;
   }
}
.plus-right{
    color: #f56c6c !important;
    font-weight: 600;
    font-size: 16px;
}
.blue-text{
    // color: #64b0ff !important;
    margin-right: 5px;
    // text-decoration: underline;
    // cursor: pointer;
  }  
  .radiobut {
    margin: 15px 0;
  }
  /deep/.el-badge__content{
  line-height: 17px;
    padding: 0 5px;
  }  
</style>
